// //群组 根组件 以及样式。 //
<style lang="stylus">
    .createTeamModal
        .Modal-header
            border-bottom 0
            padding-bottom 0

        .Modal-footer
            border-top none
            padding-top 0

    .myTeams-container
        height 100%
        overflow auto

        .myTeams-header
            display flex
            justify-content space-between
            height 32px

            .breadCrumb
                font-size 16px
                cursor pointer
                margin-right 32px

            .header-rightbox
                margin-right 0
        .team-box
            margin 0 85px 30px 0

            .tb-item
                float left
                box-shadow 0 1px 1px 0 rgba(0,0,0,0.1)

                svg
                    flex 0 0 24px
                    width 24px
                    height 24px
                    margin-left: 10px

            .team-container
                height 32px
                width 164px
                margin-right 25px
                margin-bottom 20px
                box-sizing border-box
                border-radius 6px
                cursor pointer
                user-select none
                position relative
                display flex
                align-items center
                justify-content: center;
                font-size 12px
                background-color #fff
                box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.08);
                padding-right: 10px
                color black
                &:hover{
                    color:#007fff;
                    .tc-img{
                        position: relative;
                        left: -66666px; // 修改图片颜色，移走原来svg
                        filter: drop-shadow(#007fff 66666px 0);
                    }
                    &.tbt-add{
                        background-color: #0076f1;
                    }
                }
                &.tbt-add{
                    background-color: #017fff;
                    color white
                }
                &.tbt-add svg{
                    stroke:white;
                }
                .tc-img
                    color #fff
                    margin-left: 10px
                .tc-text
                    overflow hidden
                    text-overflow ellipsis
                    box-sizing border-box
                    border none
                    outline none
                    cursor pointer
                    width 100%
                    user-select none
                    white-space nowrap

                .tc-menu
                    fill #9b9ea1
                    flex 0 0 17px
                    height 100%
                    padding-right 10px

        .team-detail
            .team-members
                clear both
                margin-bottom 30px

                .tm-header
                    font-size 18px

                .tm-body
                    margin-top 10px
                    display inline-block

                    &::after
                        content ''
                        clear both

                    .ed-tooltip
                        float left

                    .avatar
                        position relative
                        width 40px
                        height 40px
                        line-height 40px
                        border-radius 50%
                        text-align center
                        background #ccc
                        float left
                        margin-right 10px

                        .avatar-img
                            position absolute
                            left 0
                            top 0
                            width 100%
                            height 100%
                            border-radius 50%
                            z-index 2

                        .Icon
                            color #ffffff
                            position absolute
                            left 0
                            top 0
                            bottom 0
                            right 0
                            line-height 40px
                            z-index 1

            .team-files
                clear both

                .tf-header
                    font-size 18px

                .tf-body
                    margin-top 10px

    .modal-shareLink
        //width 600px
        //height 320px
        //position absolute
        //top 50%
        //left 50%
        //background #fff
        //transform translate(-50%, -50%)
        //box-shadow 0 1px 3px rgba(0, 0, 0, 0.3)
        .body
            .text-1
                font-size 14px
                margin-bottom 20px

                a
                    color #017eff
                    background 0 0
                    text-decoration none
                    outline 0
                    cursor pointer
                    transition color 0.2s ease

                    &:hover
                        color #57a3f3

            .share-box
                display flex
                margin-bottom 24px

                .text-link
                    flex: 1 1 auto;
                    height: 32px;
                    line-height: 32px;
                    font-size: 12px;
                    color: #333;
                    border-radius: 4px 0 0 4px;
                    border: 1px solid rgba(0,0,0,0.08);
                    border-right: 0;
                    padding-left: 10px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;

                .clipaction
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #017eff;
                    color: #fff;
                    font-size: 12px;
                    height: 30px;
                    margin-left: 16px;
                    border-radius: 4px;
                    text-decoration: none;
                    padding: 0 15px;
                    white-space: nowrap;
                    outline: 0;
                    cursor: pointer;
                    transition: color 0.2s ease;
                    border-left: 1px solid #e7e9eb;

                .team-share-dropdown
                    display flex
                    align-items center
                    justify-content center
                    color #353535
                    padding 0 10px
                    background 0 0
                    text-decoration none
                    outline 0
                    cursor pointer
                    transition color 0.2s ease
                    border 1px solid rgba(0,0,0,0.08)
                    border-radius 0 4px 4px 0
                    border-left 0
                    z-index 1
                    .ios-arrow
                        margin-left -5px
                    .ed-dropdown
                        height 30px
                        .ed-dropdown-text
                            height 30px
                            line-height 30px

        .exit-team
            margin-bottom 16px
            cursor pointer
            &:hover
                color #017eff
        .member-list
            max-height 400px
            overflow auto
            padding-right 10px
            margin-bottom 16px

            &::-webkit-scrollbar
                width 4px

            .member-item
                display flex
                align-items center
                justify-content space-between
                font-size 14px
                margin-bottom 16px

                .member-info
                    display flex
                    align-items center

                    .member-avatar
                        width 30px
                        height 30px
                        position relative
                        border-radius 50%

                        img
                            width 30px
                            height 30px
                            z-index 2
                            position relative
                            border-radius 50%

                        svg
                            width 30px
                            height 30px
                            z-index 1
                            border-radius 50%

                        .no-icon
                            display block
                            width 30px
                            height 30px
                            margin 0 auto
                            line-height 30px
                            text-align center
                            color #7A5923
                            font-size 14px
                            background #FFF8E5
                            border-radius 50%
                            cursor pointer
                            margin-right 10px

                    .member-name
                        margin-left 10px

        .Modal-footer
            border 0
            padding 0

    .ivu-modal-wrap.go-teams-modal
          .ivu-modal
                .ivu-modal-body
                      height 400px
                      display flex
                      flex-direction column
                      justify-content center
                      align-items center
                      .tip
                            margin 24px 0
                      .go-teams-btn
                            border-radius  6px
                            height 28px
                            line-height 28px
                            background #017FFF
                            padding 0 20px
                            cursor pointer
                            color #fff
                            &:hover
                                  opacity 0.8
</style>
<template>
    <div class="myTeams-container" @contextmenu.prevent="">
        <list v-show="!$route.query.id" :teams="teams" :loadingStatus="loadingStatus" />
        <keep-alive>
            <!-- <detail v-show="$route.query.id" /> -->
            <teamDetail v-show="$route.query.id" />
        </keep-alive>
        <!-- <div
            v-if="vip"
            class="mc-storage"
        >
            <div class="mcs-txt">
                {{ $t('usedSpace') }}：{{ space.used }} / {{ space.total }}
            </div>
            <div class="mcs-range">
                <div
                    :style="{width:usedWidth+'px'} "
                    class="mcsr-used"
                />
            </div>
        </div> -->
    </div>
</template>

<i18n>
{
  "zh": {
    "usedSpace": "已用空间",
    "joinTeamFailed": "加群失败",
    "invalidInviteUrl": "无效的邀请链接！",
    "fullTeam": "已满员！",
    "maxTeamMember": "该群的成员数量已达上限！",
    "spaceLinkInvalid": "该空间链接已失效，请联系空间管理员"
  },
  "en": {
    "usedSpace": "Used space",
    "joinTeamFailed": "Join operation failed",
    "invalidInviteUrl": "Invalid invitation link",
    "fullTeam": "Maximum Number of Groups Reached",
    "maxTeamMember": "The number of members of this group has reached the limit!",
    "spaceLinkInvalid": "This space has been disbanded or you do not have the permissions for this space yet, please contact the space administrator to confirm."
  },
  "fr": {
    "usedSpace": "Espace utilisé",
    "joinTeamFailed": "Échec de l'ajout du groupe",
    "invalidInviteUrl": "Lien d'invitation non valide!",
    "fullTeam": "Complet!",
    "maxTeamMember": "Le nombre de membres de ce groupe a atteint la limite supérieure!",
    "spaceLinkInvalid": "Cet espace a été supprimé ou vous ne disposez pas encore des autorisations nécessaires. Veuillez contacter l'administrateur de l'espace pour confirmer."
  },
  "jp": {
    "usedSpace": "使用したスペース",
    "joinTeamFailed": "グループを追加できませんでした",
    "invalidInviteUrl": "招待リンクが無効です！",
    "fullTeam": "メンバー数が上限に達しました！",
    "maxTeamMember": "このグループのメンバー数が上限に達しました！",
    "spaceLinkInvalid": "このスペースは削除されているか、このスペースの権限がまだありません。スペース管理者に連絡して確認してください。"
  },
  "de": {
    "usedSpace": "Belegter Speicherplatz",
    "joinTeamFailed": "Join-Vorgang fehlgeschlagen",
    "invalidInviteUrl": "Ungültiger Einladungslink!",
    "fullTeam": "Maximale Anzahl  Gruppen erreicht!",
    "maxTeamMember": "Die Anzahl der Mitglieder dieser Gruppe hat das Limit erreicht!",
    "spaceLinkInvalid": "Dieser Bereich ist nicht mehr verfügbar oder Sie verfügen noch nicht über die Berechtigungen für diesen Bereich. Bitte wenden Sie sich zur Bestätigung an den Bereichsadministrator."
  },
  "es": {
    "usedSpace": "Espacio usado",
    "joinTeamFailed": "Operación de unión fallida",
    "invalidInviteUrl": "Enlace de invitación inválido",
    "fullTeam": "Número máximo de grupos alcanzados",
    "maxTeamMember": "¡El número de miembros de este grupo ha alcanzado el límite!",
    "spaceLinkInvalid": "Este espacio se ha disuelto o aún no tienes los permisos de este. Ponte en contacto con el administrador para confirmarlo."
  },
  "pt": {
    "usedSpace": "Espaço usado",
    "joinTeamFailed": "Falha na operação juntar",
    "invalidInviteUrl": "Ligação de convite inválida",
    "fullTeam": "Atingido o Número Máximo de Grupos",
    "maxTeamMember": "O número de membros deste grupo atingiu o limite!",
    "spaceLinkInvalid": "Este espaço foi desativado ou você ainda não tem as permissões para usá-lo. Entre em contato com o administrador do espaço para confirmar."
  },
  "it": {
    "usedSpace": "Spazio Utilizzato",
    "joinTeamFailed": "Operazione di unione fallita.",
    "invalidInviteUrl": "Link di Invito non Valido",
    "fullTeam": "Numero Massimo di Team Raggiunto",
    "maxTeamMember": "È stato raggiunto il numero massimo di membri per questo Team!",
    "spaceLinkInvalid": "Questo spazio è stato disattivato o non disponi ancora delle autorizzazioni per l'uso. Contatta l'amministratore per confermare."
  },
  "tw": {
    "usedSpace": "已用空間",
    "joinTeamFailed": "加群失敗",
    "invalidInviteUrl": "無效的邀請連結！",
    "fullTeam": "已滿員！",
    "maxTeamMember": "該群的成員數量已達上限！",
    "spaceLinkInvalid": "此空間已解散，或您尚未擁有此空間的權限，請聯絡空間管理員進行確認。"
  },
  "kr": {
    "usedSpace": "사용된 공간",
    "joinTeamFailed": "그룹 가입 실패",
    "invalidInviteUrl": "무효 초대 링크!",
    "fullTeam": "그룹 인원수가 최대치에 도달했습니다!",
    "maxTeamMember": "그룹 멤버수가 제한에 도달했습니다!",
    "spaceLinkInvalid": "이 공간은 해체되었거나 아직 이 공간에 대한 권한이 없습니다. 공간 관리자에게 문의하여 확인하세요."
  },
  "id": {
    "usedSpace": "Ruang yang digunakan",
    "joinTeamFailed": "Penggabungan gagal",
    "invalidInviteUrl": "Tautan undangan tidak valid",
    "fullTeam": "Jumlah Grup Maksimum telah Tercapai",
    "maxTeamMember": "Jumlah anggota dalam grup ini telah mencapai batas maksimum!"
  }
}
</i18n>

<script>
    import list from "./list";
    // import detail from "./detail";
    import teamDetail from "./teamDetail";
    export default {
        name: "MyTeams",
        components: {
            list,
            // detail,
            teamDetail,
        },
        data() {
            return {
                loadingStatus: false,
            };
        },
        computed: {
            teams() {
                return this.$store.state.team.teams;
            },
            space() {
                return this.$store.state.team.space;
            },
            usedWidth() {
                return (parseFloat(this.space.used) / parseFloat(this.space.total)) * 200;
            },
            userInfo() {
                return this.$store.state.userInfo;
            },
        },
        methods: {
            updateTeam() {
                this.loadingStatus = true;
                // this.$store.commit("setState", { data: true, type: "showLoading" });
                let code = this.$route.query.inviteCode;
                console.log("code", code);
                if (code) {
                    this.$store
                        .dispatch("joinTeamByCode", code)
                        .then((joinData) => {
                            this.$bus.$emit("changeSlide", 10);
                            this.$store.dispatch("getTeamList").then((res) => {
                                let list = res.data;
                                for (let i = list.length - 1; i >= 0; i--) {
                                    if (list[i].id == joinData.data.team_id) {
                                        this.$router.push("teams?id=" + list[i].id);
                                        break;
                                    }
                                }
                                this.$store.commit("setState", {
                                    data: false,
                                    type: "showLoading",
                                });
                                this.loadingStatus = false;
                            });
                        })
                        .catch((err) => {
                            if (err == "ticketInvalide") {
                                this.$store.dispatch("getTeamList").then(() => {});
                                // this.$Modal.error({
                                //     title: this.$t("joinTeamFailed"),
                                //     content: this.$t("invalidInviteUrl"),
                                //     onOk: () => {
                                //         this.$bus.$emit('changeSlide', 10);
                                //     }
                                // });
                                this.$bus.$emit("joinTeamFailed", this.$t("spaceLinkInvalid"));
                            } else if (err == "memberNumLimit") {
                                this.$store.dispatch("getTeamList").then(() => {});
                                this.$Modal.warning({
                                    title: this.$t("fullTeam"),
                                    content: this.$t("maxTeamMember"),
                                    onOk: () => {
                                        this.$bus.$emit("changeSlide", 10);
                                    },
                                });
                            }
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                            this.loadingStatus = false;
                        });
                } else {
                    this.$store.dispatch("getTeamList").then(() => {
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                        this.loadingStatus = false;
                    });
                }

                if (this.vip) {
                    this.$store.dispatch("getTeamSpace");
                }
            },
        },
        watch: {
            $route: {
                immediate: true,
                handler: function (to) {
                    let teamId = to.query.id;
                    if (teamId) {
                        this.$store.commit("toCurTeamId", teamId);
                    }
                },
            },
            vip(val) {
                if (val) {
                    this.$store.dispatch("getTeamSpace");
                }
            },
        },
        created() {
            // if (!this.$validateLogin()) return;
            this.$store.commit("setState", { data: 21, type: "selectId" });
            if (this.userInfo) {
                this.updateTeam();
            } else {
                setTimeout(() => {
                    this.$bus.$emit("login");
                }, 1000);
                this.$bus.$on("loginSucc-team", () => {
                    this.updateTeam();
                });
            }
        },
        beforeDestroy() {
            this.$bus.$off("loginSucc-team");
        },
    };
</script>
